import { TYPES } from "./stripe.type";

const initState = {
  account: null,
};

const stripeReducer = (state = initState, action) => {
  const { type, payload } = action;
  switch (type) {
    case TYPES.GET_STRIPE_ACCOUNT_SUCCESS:
      return {
        ...state,
        account: payload,
      };
    default:
      return state;
  }
};

export default stripeReducer;
